export const data = [
  {
    id: 1,
    src: 'https://source.unsplash.com/random/?mountain,beach,vacation,rv',
    title: 'Property 6',
    location: 'San Jose, CA',
    views: '396 k views',
    createdAt: 'a week ago',
    price: 10000,
    isFavorited: false
  },
  {
    id: 2,
    src: 'https://source.unsplash.com/random/?mountain,beach,vacation,rv',
    title: 'Property 7',
    location: 'Paris, France',
    views: '2.1 M views',
    createdAt: '4 months ago',
    price: 22341.12,
    isFavorited: false
  },
  {
    id: 3,
    src: 'https://source.unsplash.com/random/?mountain,beach,vacation,rv',
    title: 'Property 8',
    location: 'Tampa, FL',
    views: '130 M views',
    createdAt: '10 months ago',
    price: 13412,
    isFavorited: false
  },
  {
    id: 4,
    src: 'https://source.unsplash.com/random/?mountain,beach,vacation,rv',
    title: 'Property 9',
    location: 'Lake Tahoe, CA',
    views: '112 k views',
    createdAt: 'a week ago',
    price: 39.99,
    isFavorited: false
  },
  {
    id: 5,
    src: 'https://source.unsplash.com/random/?mountain,beach,vacation,rv',
    title: 'Property 10',
    location: 'Dallas, TX',
    views: '112 views',
    createdAt: '4 hours ago',
    price: 19000,
    isFavorited: false
  },
];

export const listings = [
  {
    id: 6,
    src: 'https://source.unsplash.com/random/?mountain,beach,vacation,rv',
    title: 'Property 1',
    location: 'San Jose, CA',
    views: '396 k views',
    createdAt: 'a week ago',
    isFavorited: true
  },
  {
    id: 7,
    src: 'https://source.unsplash.com/random/?mountain,beach,vacation,rv',
    title: 'Property 2',
    location: 'Paris, France',
    views: '2.1 M views',
    createdAt: '4 months ago',
    isFavorited: true
  },
  {
    id: 8,
    src: 'https://source.unsplash.com/random/?mountain,beach,vacation,rv',
    title: 'Property 3',
    location: 'Tampa, FL',
    views: '130 M views',
    createdAt: '10 months ago',
    isFavorited: true
  },
  {
    id: 9,
    src: 'https://source.unsplash.com/random/?mountain,beach,vacation,rv',
    title: 'Property 4',
    location: 'Lake Tahoe, CA',
    views: '112 k views',
    createdAt: 'a week ago',
    isFavorited: true
  },
  {
    id: 10,
    src: 'https://source.unsplash.com/random/?mountain,beach,vacation,rv',
    title: 'Property 5',
    location: 'Dallas, TX',
    views: '112 views',
    createdAt: '4 hours ago',
    isFavorited: true
  },
];